import TestMetaData from "component/metadata/TestMetaData";
import {TextInput} from "component/input/TextInput";
import {useEffect, useState} from "react";
import axios from "axios";
import {restUrl} from "../../../../apiUrl";
import {useLocation} from "react-router-dom";

export const AboutTest = ({title, subTitle, metaData, onChange, children}) => {
    const {state} = useLocation()
    const [fixed, setFixed] = useState();
    useEffect(() => {
        axios.get(`${restUrl}/activity_test_view_header_create?test_id=eq.${state.testId}`).then(data => {
            setFixed(data.data[0])
        })
    }, []);
    return (
        <>
            <h2>{title}</h2>
            <p style={{marginTop: "30px"}}>{subTitle}</p>
            {fixed && <TestMetaData header={Object.keys(fixed)} data={Object.values(fixed)}/>}
            {children}
            <table>
                <thead>
                <tr>
                    <th>시험 개요</th>
                    <th>출제자 메모</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td><TextInput value={metaData} toChange="summary" onChange={onChange}/></td>
                    <td><TextInput value={metaData} toChange="memo" onChange={onChange}/></td>
                </tr>
                </tbody>
            </table>
        </>
    )
}